import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 32 31",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<ellipse cx="16.387" cy="15.296" rx="15.444" ry="15.296"/> <ellipse cx="16.387" cy="10.362" fill="#fff" rx="4.484" ry="4.441"/> <ellipse cx="16.387" cy="21.711" fill="#fff" rx="8.469" ry="3.947"/>' }
  })
);